import { RealEstateDto } from "api/real-estate";
import { BranchCode } from "api/risk";
import { Dispatch, FC, SetStateAction } from "react";
import { RealEstateEligibility } from "./RealEstateEligibity";
import { RgiRealEstateEligibility } from "./RgiRealEstateEligibility";

interface RealEstateEligibilitySectionProps {
  branchCode: BranchCode;
  selectedRealEstateId: string;
  selectedRealEstate?: RealEstateDto;
  onEligibilityChange: (eligibility: boolean) => void;
  setPostSubmit: Dispatch<SetStateAction<(() => Promise<void>) | undefined>>;
  refreshKey?: number;
}

export const RealEstateEligibilitySection: FC<RealEstateEligibilitySectionProps> = ({
  branchCode,
  selectedRealEstateId,
  selectedRealEstate,
  onEligibilityChange,
  setPostSubmit,
  refreshKey
}) => {
  if (branchCode === BranchCode.UPI) {
    return (
      <RealEstateEligibility
        realEstateId={selectedRealEstateId}
        onEligibilityChange={onEligibilityChange}
        branchCode={branchCode}
        refreshKey={refreshKey}
      />
    );
  }

  if (branchCode === BranchCode.RGI && selectedRealEstate) {
    return (
      <RgiRealEstateEligibility
        selectedRealEstate={selectedRealEstate}
        onEligibilityChange={onEligibilityChange}
        setPostSubmit={setPostSubmit}
      />
    );
  }

  return null;
};
